export enum actionTypes {
    REQUEST_USER_SETTINGS = "request_user_settings",
    RECEIVE_USER_SETTINGS = "receive_user_settings",
    COMPLETE_USER_SETTINGS = "complete_user_settings",

    REQUEST_DELEGATEE_LIST = "request_delegatee_list",
    RECEIVE_DELEGATEE_LIST = "receive_delegatee_list",
    COMPLETE_DELEGATEE_LIST = "complete_delegatee_list",

    REQUEST_UPDATE_USER_SETTINGS = "request_update_user_settings",
    RECEIVE_UPDATE_USER_SETTINGS = "receive_update_user_settings",
    COMPLETE_UPDATE_USER_SETTINGS = "complete_update_user_settings",

    UPDATE_USER_SETTINGS = "update_user_settings",
}
